<template>
  <v-app>
    <v-main>
        <div class="header-ubiq">
          <div class="mt-4 mb-2 ml-6 logo">
            <a href="https://www.ubiq.fr" style="text-decoration:none">
              <svg width="49" height="26" viewBox="0 0 49 26" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M12.6696 6.64453V19.7237H8.93573L8.67828 18.2585C7.88038 19.3314 6.28368 20.0631 4.73809 20.0631C1.80212 20.0631 0 18.0749 0 14.858V6.64453H3.96575V13.3937C3.96575 15.5386 4.68697 16.4799 6.30924 16.4799C7.93151 16.4799 8.70384 15.5906 8.70384 13.4456V6.64453H12.6696Z" fill="black"/>
              <path d="M14.3864 19.7226V0H18.3522V8.1615C19.1245 6.98471 20.8244 6.19926 22.6785 6.19926C26.2837 6.19926 28.5751 9.05082 28.5751 13.3138C28.5751 17.5768 26.0253 20.063 22.369 20.063C20.566 20.063 19.0213 19.2525 18.3257 18.0488L18.1194 19.7226H14.3855H14.3864ZM21.5191 16.3749C23.3988 16.3749 24.5838 15.0405 24.5838 13.1051C24.5838 11.1698 23.3988 9.83535 21.5191 9.83535C19.6394 9.83535 18.3777 11.1429 18.3777 13.1051C18.3777 15.0674 19.665 16.3749 21.5191 16.3749Z" fill="black"/>
              <path d="M29.2881 2.30157C29.2881 1.01999 30.2923 0.0258789 31.554 0.0258789C32.8156 0.0258789 33.7943 1.01999 33.7943 2.30157C33.7943 3.58315 32.7901 4.60322 31.554 4.60322C30.3179 4.60322 29.2881 3.58315 29.2881 2.30157ZM29.5976 6.64429H33.5633V19.7235H29.5976V6.64429Z" fill="black"/>
              <path d="M40.632 6.22554C42.4606 6.22554 44.0829 7.03603 44.8041 8.23972L45.0104 6.64377H48.7443V26.0001H44.7786V18.4145C44.0318 19.4086 42.3839 20.0883 40.6065 20.0883C36.7694 20.0883 34.5547 17.106 34.5547 12.9738C34.5547 8.84156 37.0525 6.22461 40.632 6.22461V6.22554ZM41.6107 16.4531C43.4649 16.4531 44.7521 15.1456 44.7521 13.1834C44.7521 11.2211 43.4649 9.91356 41.6107 9.91356C39.7565 9.91356 38.546 11.248 38.546 13.1834C38.546 15.1187 39.731 16.4531 41.6107 16.4531Z" fill="black"/>
              </svg>

            </a>
          </div>
        </div>
      <SimuBail/>
        <div class="footer-ubiq">
          <v-container>
            <v-row>
              <v-col class="col-12 col-md-6 mt-15">
                <a href="https://www.ubiq.fr" style="text-decoration:none">
                  <svg width="49" height="26" viewBox="0 0 49 26" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M12.6696 6.64453V19.7237H8.93573L8.67828 18.2585C7.88038 19.3314 6.28368 20.0631 4.73809 20.0631C1.80212 20.0631 0 18.0749 0 14.858V6.64453H3.96575V13.3937C3.96575 15.5386 4.68697 16.4799 6.30924 16.4799C7.93151 16.4799 8.70384 15.5906 8.70384 13.4456V6.64453H12.6696Z" fill="black"/>
                  <path d="M14.3864 19.7226V0H18.3522V8.1615C19.1245 6.98471 20.8244 6.19926 22.6785 6.19926C26.2837 6.19926 28.5751 9.05082 28.5751 13.3138C28.5751 17.5768 26.0253 20.063 22.369 20.063C20.566 20.063 19.0213 19.2525 18.3257 18.0488L18.1194 19.7226H14.3855H14.3864ZM21.5191 16.3749C23.3988 16.3749 24.5838 15.0405 24.5838 13.1051C24.5838 11.1698 23.3988 9.83535 21.5191 9.83535C19.6394 9.83535 18.3777 11.1429 18.3777 13.1051C18.3777 15.0674 19.665 16.3749 21.5191 16.3749Z" fill="black"/>
                  <path d="M29.2881 2.30157C29.2881 1.01999 30.2923 0.0258789 31.554 0.0258789C32.8156 0.0258789 33.7943 1.01999 33.7943 2.30157C33.7943 3.58315 32.7901 4.60322 31.554 4.60322C30.3179 4.60322 29.2881 3.58315 29.2881 2.30157ZM29.5976 6.64429H33.5633V19.7235H29.5976V6.64429Z" fill="black"/>
                  <path d="M40.632 6.22554C42.4606 6.22554 44.0829 7.03603 44.8041 8.23972L45.0104 6.64377H48.7443V26.0001H44.7786V18.4145C44.0318 19.4086 42.3839 20.0883 40.6065 20.0883C36.7694 20.0883 34.5547 17.106 34.5547 12.9738C34.5547 8.84156 37.0525 6.22461 40.632 6.22461V6.22554ZM41.6107 16.4531C43.4649 16.4531 44.7521 15.1456 44.7521 13.1834C44.7521 11.2211 43.4649 9.91356 41.6107 9.91356C39.7565 9.91356 38.546 11.248 38.546 13.1834C38.546 15.1187 39.731 16.4531 41.6107 16.4531Z" fill="black"/>
                  </svg>
                </a>
                  <h1 class="mt-5">Faisons &eacute;quipe<br>pour trouver vos bureaux.</h1>
                  <v-btn
                    class="mt-10 pl-3 pr-3"
                    large
                    depressed
                    height="48"
                    color="#3C46DC"
                    :ripple="false"
                    href="https://www.ubiq.fr"
                    id="no-background-hover"
                  >
                    <span class="button-search">Rechercher un bureau</span>
                  </v-btn>
                  <p class="mt-15">
                    <span class="footer-text">Copyright &copy; 2026 Ubiq. Tous droits r&eacute;serv&eacute;s.</span>
                  </p>
              </v-col>
              <v-col class="col-6 text-right d-none d-lg-block">
                  <img src="./assets/reunion_566.png" class="">
              </v-col>
            </v-row>
          </v-container>
        </div>
    </v-main>
  </v-app>
</template>
<style lang="scss">
@import './sass/variables.scss';
@font-face {
  font-family: "RoobertRegular";
  src: local("RoobertRegular"),
   url('./assets/Roobert-Regular.woff') format("woff");
}
$font-family-regular: 'RoobertRegular';
$font-family-bold: 'RoobertSemiBold';
$body-font-family: 'Roobert' !important;
.logo {
  position: relative;
}
.header-ubiq { 
  border-bottom: 1px solid #cccccc;
}
#no-background-hover::before {
   background-color: #302AA7 !important;
}
#no-background-hover:hover {
   background-color: #302AA7 !important;
}
.button-search:hover {
  background-color: transparent !important;
}
.button-search {
  background-color: transparent !important;
  font-size: 15px;
  font-weight: $btn-font-weight;
  // letter-spacing: 0.2px;
  // margin: 12px;
  color: white;
  // height: 48px;
  text-transform: none;
  // color: white;
  font-family: $font-family-regular;
  text-align: center;
  width: 194px;
}
.footer-ubiq {
  background-color: #F9F9FA;
}
.footer-text {
    font-size: 14px;
    font-weight: 400;
    line-height: 16px;
    // font-family: $font-family-regular;
    color: gray;
    text-align: left!important;
}

.standard-color {
    background-color:#3C46DC;
    color: white;
}
.v-btn {
    color:#3C46DC;
    height:48px;
    text-transform: none;
}
.v-btn::before {
    background-color: transparent;
}
.v-btn span:hover{
    background-color: #302AA7;
  }
.theme--light .v-btn {
    color: white;
}
</style>
<script>
import SimuBail from './components/SimuBail.vue';

export default {
  name: 'App',

  components: {
    SimuBail,
  },

  data: () => ({
    //
  }),
};
</script>
